export class ResetProjectWikisList {
  public static readonly type = '[Project/Wiki/List] ResetProjectWikisList';
}
